<template>
    <div class="p-4">
        <Topbar></Topbar>
        <h1>Vuex Store Main</h1>
        <div>State count: {{stageCount}}</div>
        <div>Local count: {{countLocal}}</div>
        <div>
            <button @click="clickInc()">Increment State</button>
            &nbsp;
            <button @click="clickIncLocal()">Increment local</button>
        </div>

        <div class="card mt-4">
            <div class="card-body" v-if="isProfileLoaded">
                <div>Profile segment</div>
                <div>{{profileDisplayName}}</div>
                <div>Point {{$store.getters.getProfile.updated_points.points}}</div>
                <div>Point {{points}}</div>
                <div>
                    <button @click="updateProfilePoint()">Update Point</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
// import Account from "@/helper/AccountHelper.js";
// import Util from "@/helper/Utility.js";
import Topbar from "./component/Topbar.vue";

export default {
    name: "VuexStoreMain",
    components: {
        Topbar,
    },
    data: function() {
        return {
            count: 0,

            // pointFormat: '',
            profileName: '',
            point: 0,
        };
    },
    computed: {
        countLocal: function() {
            return this.count;
        },

        ...mapState({
            stageCount: state => state.count.count,
            isProfileLoaded: state => state.profile.isLoaded,
            profileDisplayName: state => state.profile.data.displayName,
            points: state => state.profile.data.updated_points.points,
        }),
    },
    methods: {
        clickInc: function() {
            this.$store.commit('increment');
            // console.log(this.$store.getters.getCount);
            // Util.log(this.$store.getters.getProfile);
        },
        clickIncLocal: function() {
            this.count++;
        },
        updateProfilePoint: function() {
            this.count += 100;
            this.$store.commit('updatePoints', this.count);
        },
    },
}
</script>
